import { useParams, Link } from 'react-router-dom';
import { usePost } from '../hooks';
import { PostEditor } from '../components';
import './AdminEditPage.css';

export function AdminEditPage() {
  const { id } = useParams();
  const { post, loading, error } = usePost(id);

  if (loading) {
    return (
      <div className="admin-edit-page__loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="admin-edit-page__error">
        <p className="text-muted">{error || 'Post not found'}</p>
        <Link to="/admin" className="text-sans">
          Back to admin
        </Link>
      </div>
    );
  }

  return (
    <div className="admin-edit-page">
      <Link to="/admin" className="admin-edit-page__back text-sans text-small">
        &larr; Back to admin
      </Link>
      <PostEditor post={post} />
    </div>
  );
}
